import { render, staticRenderFns } from "./IndexGame.vue?vue&type=template&id=728a1fbf&scoped=true"
import script from "./IndexGame.vue?vue&type=script&lang=js"
export * from "./IndexGame.vue?vue&type=script&lang=js"
import style0 from "./IndexGame.vue?vue&type=style&index=0&id=728a1fbf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728a1fbf",
  null
  
)

export default component.exports